import { render, staticRenderFns } from "./AddNewIngredientModal.vue?vue&type=template&id=77c1f883&scoped=true"
import script from "./AddNewIngredientModal.vue?vue&type=script&lang=js"
export * from "./AddNewIngredientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c1f883",
  null
  
)

export default component.exports